import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-list-service-manual',
  templateUrl: './list-service-manual.component.html',
  styleUrls: ['./list-service-manual.component.scss']
})
export class ListServiceManualComponent implements OnInit {
  public serviceManualList: any = [];
  public page: any;
  public count = 6;
  constructor(public appService: AppService, private snackBar: MatSnackBar) { }

  ngOnInit() {

    this.getAllServiceManual();
  }

  public getAllServiceManual() {

    this.appService.getAllServiceManual("/api/ProductServiceManual").subscribe(data => {

      this.serviceManualList = data;
    });
  }

  public catalogueDelete(id) {
    this.appService.deleteProductCatalogue(`api/ProductServiceManual?productmanualserviceid=${id}`, {}).subscribe(data => {
    },
      (error) => {
        this.snackBar.open('Service catalogue delete successfully.', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
        this.getAllServiceManual();
      });
  }

  public onPageChanged(event) {
    this.page = event;
    window.scrollTo(0, 0);
  }

}
